import { useOktaAuth } from '@okta/okta-react';
import { useEffect} from 'react';
import { useParams } from "react-router-dom";

/** MyMine Version2.1 DirectContents画面新規追加 
 * DirectContents Component
 */
const DirectContents = () => {

  const queryParam = useParams();
  const {oktaAuth } = useOktaAuth();

  useEffect(() => {
    oktaAuth.setOriginalUri(`${queryParam.encryptParam}`);
    oktaAuth.signInWithRedirect();
  })
};
export default DirectContents;
